import { useEffect } from "react";
import { getLayoutDirection } from "../../utils/util";

const MedicalFitnessStatusResult = ({ refNo, status, onBack, translationMap, isMobile }) => {
  useEffect(() => {
    window.parent.scrollTo(0, 0);
  }, []);
  return (
    <div className={`custombody_color ${getLayoutDirection()}`}>
            <section className="w-100 clearfix ManageDependentMainSection" id="CoverPlanActive">
                <div className="container customContainer">
                    {!isMobile &&
          <div className="Title_Inner_Box">
                            <h6 className="MainTitleOne"> {translationMap?.medicalResultTitle}</h6>
                        </div>
          }
                    <div className="cover_inner_wrapper cover_inner_wrapper2">
                        <div className="cover_main_box1">
                            <div className="medical_fitness_white_box">
                                <div className="medical_white_process_box">
                                    <p className="Gray_Title">
                                        # {" "}
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                        <a href="javascript:void(0);">
                                            {refNo}
                                        </a>
                                    </p>
                                    <div className="title_txt">
                                        <h6 className="Gray_Title">
                                            {status}
                                        </h6>
                                    </div>
                                </div>
                                <div className="medical_white_proces_btn_box">

                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                    <a href="javascript:void(0);" className="bluetrans_btn_link"
                  onClick={() => onBack()}>
                                        {translationMap?.back}
                                    </a>

                                </div>
                            </div>
                        </div>
                        <div className="cover_main_box2">

                        </div>
                    </div>
                </div>
            </section>
        </div>);

};

export default MedicalFitnessStatusResult;